// 登录 / 注册 / 绑手机 共用的表单校验与倒计时（唯一真源）
// 原本在 LoginModal、LoginView 里各存一份，实现字节级一致。
//
// 注意：validatePhone 在 BindPhoneDialog 里的错误文案不同（手机号格式不正确），
// 所以该组件保留自己的实现，不使用这里的版本。

export const validateAccount = (account) => {
  if (!account) return '请输入账号'
  return ''
}

export const validatePassword = (password) => {
  if (!password) return '请输入密码'
  if (password.length < 6) return '密码长度至少为6位'
  return ''
}

export const validatePhone = (phone) => {
  if (!phone) return '请输入手机号'
  if (!/^1[3-9]\d{9}$/.test(phone)) return '请输入正确的手机号'
  return ''
}

export const validateCaptcha = (captcha) => {
  if (!captcha) return '请输入验证码'
  if (captcha.length !== 6) return '验证码为6位数字'
  return ''
}

export const startCountdown = (countdownRef, seconds = 60) => {
  countdownRef.value = seconds
  const timer = setInterval(() => {
    countdownRef.value--
    if (countdownRef.value <= 0) clearInterval(timer)
  }, 1000)
}

